import React from 'react';
import '../../styles/News.css';

const News = () => {
  return (
    <div className="news-container">
      {/* Header */}
      <div className="news-header">
        <h1 className="news-title">NEWS</h1>
        <p className="news-subtitle">Stay updated with the latest news, partnerships, and community highlights from Victoria Sports Club — where excellence in sports and hospitality come together.</p>
      </div>
      
          <div className="news-card alternate">
              <div className="news-image">
                <img src="/vscimages/news/wilbert.png" alt="Wilbert Ross Press Release" />
              </div>
              <div className="news-content">
                {/* <h1>EXPTRAVEL.PH</h1> */}
                <h2 className="news-item-title">Wilbert Ross Cover Story Filmed at Victoria Sports Club</h2>
                {/* <p className="news-item-sub">A new space for wellness and productivity in Quezon City</p> */}
                <p className="news-item-body">
                  There’s something different about Wilbert Ross and you don’t need to look twice to feel it.
                </p>
                      <div className="news-links-wrapper">
                        <span className="read-more-label">Read More →</span>
                        <div className="source-links">
                          <a href="https://villagepipol.com/wilbert-ross-a-perfect-time-to-be-seen/" target='_blank' rel='noreferrer'>Village Pipol</a>
                        </div>
                      </div>
              </div>
      </div>

       {/* 1st News Card (Alternate) */}
          <div className="news-card">
            <div className="news-image">
              <img src="/vscimages/news/babaeako.jpg" alt="" />
            </div>
            <div className="news-content">
              {/* <h1>VILLAGEPIPOL</h1> */}
              <h2 className="news-item-title">“Babae Ako” event, Tampok ang inspirasyon ng kababaihan</h2>
              {/* <p className="news-item-sub">A new space for wellness and productivity in Quezon City</p> */}
              <p className="news-item-body">
              Celebrated the success and inspiration of women at the Women’s Month event in Quezon City. 
              </p>
                <div className="news-links-wrapper">
                  <span className="read-more-label">Read More →</span>
                  <div className="source-links">
                    <a href="https://www.facebook.com/share/v/1GPwkwVLtg/" target='_blank' rel='noreferrer'>Net25 News & Information FB</a>
                    <a href="https://www.youtube.com/watch?v=4CXP0X-5rrQ" target='_blank' rel='noreferrer'>Net25 News & Information YT</a>
                  </div>
                </div>
             
            </div>
          </div>

      <div className="news-card alternate">
              <div className="news-image">
                <img src="/vscimages/news/babaeako.jpg" alt="Victory Run 2025 Delivers Star Power, Purpose, and Pure Community Energy" />
              </div>
              <div className="news-content">
                {/* <h1>EXPTRAVEL.PH</h1> */}
                <h2 className="news-item-title">“Babae Ako”: A Women’s Month Escape in Quezon City That Blends Wellness, Beauty, and Inspiration</h2>
                {/* <p className="news-item-sub">A new space for wellness and productivity in Quezon City</p> */}
                <p className="news-item-body">
                  For many women professionals in Metro Manila, balancing work, wellness, and personal time can feel like a daily marathon. This Women’s Month, VS Hotel Convention Center invites women to take a meaningful pause with “Babae Ako,” a lifestyle experience that combines hospitality, wellness, beauty, and inspiration in one destination.",
                </p>
                      <div className="news-links-wrapper">
                        <span className="read-more-label">Read More →</span>
                        <div className="source-links">
                          <a href="https://www.blogapalooza.ph/post/babae-ako-a-women-s-month-escape-in-quezon-city-that-blends-wellness-beauty-and-inspiration/" target='_blank' rel='noreferrer'>Blogapalooza</a>
                        </div>
                      </div>
              </div>
      </div>

      {/* 1st News Card (Alternate) */}
          <div className="news-card">
            <div className="news-image">
              <img src="/vscimages/news/village.jpg" alt="" />
            </div>
            <div className="news-content">
              {/* <h1>VILLAGEPIPOL</h1> */}
              <h2 className="news-item-title">Love Starts Within, Grows With Community: A Lifestyle Celebration at Victoria Sports Club and VS Hotel Convention Center</h2>
              {/* <p className="news-item-sub">A new space for wellness and productivity in Quezon City</p> */}
              <p className="news-item-body">
              That spirit came alive at “Stay Lucky in Love,” recently held at Victoria Sports Club and VS Hotel Convention Center. The gathering felt less like a typical event and more like a lifestyle reset shared with friends, mentors, creators, and community leaders who believe that growth is better when experienced together. 
              </p>
                <div className="news-links-wrapper">
                  <span className="read-more-label">Read More →</span>
                  <div className="source-links">
                    <a href="https://villagepipol.com/love-starts-within-grows-with-community-a-lifestyle-celebration-at-victoria-sports-club-and-vs-hotel-convention-center/..." target='_blank' rel='noreferrer'>Village Pipol</a>
                    <a href="IwY2xjawQDlOtleHRuA2FlbQIxMQBicmlkETJIM2NzQThTeVl0d0UxeVVlc3J0YwZhcHBfaWQQMjIyMDM5MTc4ODIwMDg5MgABHorU8B4YBpiP15mAwK2wRnVEWQqKFD2GrYLU5rkldjmYaKA20z1ISqjSU2BB_aem_A0kr48o30Y7gwbKaftxLCA" target='_blank' rel='noreferrer'>Experience Travel PH</a>
                  </div>
                </div>
             
            </div>
          </div>

          {/* 2nd News Card */}
      <div className="news-card alternate">
        <div className="news-image">
          <img src="/vscimages/news/untv-hotel.jpg" alt="Victory Run 2025 Delivers Star Power, Purpose, and Pure Community Energy" />
        </div>
        <div className="news-content">
          {/* <h1>EXPTRAVEL.PH</h1> */}
          <h2 className="news-item-title">UNTV’s Good Morning Kuya Featurey</h2>
          {/* <p className="news-item-sub">A new space for wellness and productivity in Quezon City</p> */}
          <p className="news-item-body">
            Good Morning Kuya featured VS Hotel Convention Center last February 11, 2026, highlighting the property’s inviting spaces, modern facilities, and dedication to delivering comfortable and memorable guest experiences.
                            During the segment, viewers witnessed an inside look at the hotel’s amenities and convention capabilities, underscoring its role as a premier destination for both leisure stays and business events.",
          </p>
                <div className="news-links-wrapper">
                  <span className="read-more-label">Read More →</span>
                  <div className="source-links">
                    <a href="https://www.facebook.com/GoodMorningKuya/videos/1541879046916085/" target='_blank' rel='noreferrer'>Good Morning Kuya</a>
                  </div>
                </div>
        </div>
      </div>



      {/* 2nd News Card (Alternate) */}
      <div className="news-card ">
        <div className="news-image">
          <img src="/vscimages/news/gm.jpg" alt="Victoria Sports Club Contract Signing with Save the Children Foudnation" />
        </div>
        <div className="news-content">
          {/* <h1>EXPTRAVEL.PH</h1> */}
          <h2 className="news-item-title">Victory Run 2025 Delivers Star Power, Purpose, and Pure Community Energy</h2>
          {/* <p className="news-item-sub">A new space for wellness and productivity in Quezon City</p> */}
          <p className="news-item-body">
          Dr. Isic also shared that Victoria Sports Club continues to elevate its lifestyle offerings, including a private and exclusive cinema now screening box office movies from Metro Manila Film Festival. This December, the cinema lineup featured “Call Me Mother” and “Shake Rattle and Roll: Evil Origin,” adding a unique entertainment experience for members and guests.
          </p>

                 <div className="news-links-wrapper">
                  <span className="read-more-label">Read More →</span>
                  <div className="source-links">
                    <a href="https://www.exptravelph.com/post/victory-run-2025-delivers-star-power-purpose-and-pure-community-energy?fbclid=IwY2xjawPdCWpleHRuA2FlbQIxMQBzcnRjBmFwcF9pZBAyMjIwMzkxNzg4MjAwODkyAAEeqKvTZzXI1Lrt0GGm9a56haCv1QGbEIR9a_UYcwOIHd0j8SVqo4ZCqmSrorw_aem_dpkcaAku7aD7rjF0Rq25Yw" target='_blank' rel='noreferrer'>Experience Travel PH</a>
                  </div>
                </div>
          
        </div>
      </div>

       {/* 2nd News Card */}
      <div className="news-card alternate">
        <div className="news-image">
          <img src="/vscimages/news/bardon.jpg" alt="Victory Run 2025 Delivers Star Power, Purpose, and Pure Community Energy" />
        </div>
        <div className="news-content">
          {/* <h1>EXPTRAVEL.PH</h1> */}
          <h2 className="news-item-title">Victory Run 2025 Delivers Star Power, Purpose, and Pure Community Energy</h2>
          {/* <p className="news-item-sub">A new space for wellness and productivity in Quezon City</p> */}
          <p className="news-item-body">
            Held last December 21, Victory Run 2025 proved that fitness, fun, and advocacy can come together in one unforgettable event. The fun run gathered an exciting mix of celebrities, influencers, and everyday runners, transforming the venue into a vibrant celebration of movement and community spirit.",
          </p>
                <div className="news-links-wrapper">
                  <span className="read-more-label">Read More →</span>
                  <div className="source-links">
                    <a href="https://www.exptravelph.com/post/victory-run-2025-delivers-star-power-purpose-and-pure-community-energy?fbclid=IwY2xjawPdCWpleHRuA2FlbQIxMQBzcnRjBmFwcF9pZBAyMjIwMzkxNzg4MjAwODkyAAEeqKvTZzXI1Lrt0GGm9a56haCv1QGbEIR9a_UYcwOIHd0j8SVqo4ZCqmSrorw_aem_dpkcaAku7aD7rjF0Rq25Yw" target='_blank' rel='noreferrer'>Experience Travel PH</a>
                  </div>
                </div>
        </div>
      </div>


       {/* 3rd News Card (Alternate) */}
      <div className="news-card">
        <div className="news-image">
          <img src="/vscimages/news/run.jpg" alt="Victoria Sports Club Contract Signing with Save the Children Foudnation" />
        </div>
        <div className="news-content">
          {/* <h1>MANILA BULLETIN</h1> */}
          <h2 className="news-item-title">Victoria Sports Club Strengthens Community Wellness Through Fun Run Initiative</h2>
          {/* <p className="news-item-sub">A new space for wellness and productivity in Quezon City</p> */}
          <p className="news-item-body">
          Victoria Sports Club, the metro’s largest integrated wellness and lifestyle destination, is set to energize the local fitness community as it stages its first-ever fun run, a landmark initiative that underscores its commitment to building healthier, more sustainable communities through active living and social responsibility.Victoria Sports Club, the metro’s largest integrated wellness and lifestyle destination, is set to energize the local fitness community as it stages its first-ever fun run, a landmark initiative that underscores its commitment to building healthier, more sustainable communities through active living and social responsibility.
          </p>
                <div className="news-links-wrapper">
                  <span className="read-more-label">Read More →</span>
                  <div className="source-links">
                    <a href="https://mb.com.ph/2025/12/20/victoria-sports-club-mounts-first-fun-run-uniting-wellness-and-advocacy" target='_blank' rel='noreferrer'>Manila Bulletin</a>
                  </div>
                </div>
          
        </div>
      </div>

      {/* 4th News Card */}
      <div className="news-card alternate">
        <div className="news-image">
          <img src="/vscimages/news/paws.png" alt="Victoria Sports Club Contract Signing with PAWS" />
        </div>
        <div className="news-content">
          {/* <h1>MANILA BULLETIN</h1> */}
          <h2 className="news-item-title">Victoria Sports Club Strengthens Community Wellness Through Fun Run Initiative</h2>
          {/* <p className="news-item-sub">A new space for wellness and productivity in Quezon City</p> */}
          <p className="news-item-body">
         Group General Manager Dr. Mario Isic shared that the fun run is a clear extension of Victoria Sports Club’s mission to help cultivate healthier communities across the metro. He emphasized that supporting non-government organizations such as Save the Children Philippines and the Philippine Animal Welfare Society highlights the club’s holistic approach to wellness and its commitment to the sustainable development of the communities it serves. ",
          </p>

          <div className="news-links-wrapper">
                  <span className="read-more-label">Read More →</span>
                  <div className="source-links">
                    <a href="https://mb.com.ph/2025/12/20/victoria-sports-club-mounts-first-fun-run-uniting-wellness-and-advocacy" target='_blank' rel='noreferrer'>Manila Bulletin</a>
                  </div>
                </div>
        </div>
      </div>


       {/* 5th News Card (Alternate) */}
      <div className="news-card">
        <div className="news-image">
          <img src="/vscimages/news/save.jpg" alt="Victoria Sports Club Contract Signing with Save the Children Foudnation" />
        </div>
        <div className="news-content">
          {/* <h1>MANILA BULLETIN</h1> */}
          <h2 className="news-item-title">Titan Ultra Giant Risers partner with Victoria Sports Club</h2>
          {/* <p className="news-item-sub">A new space for wellness and productivity in Quezon City</p> */}
          <p className="news-item-body">
          The Pureblends Titan Ultra Giant Risers have officially designated Victoria Sports Club (VSC) as their training hub for the upcoming PBA 50th Season, following a Memorandum of Agreement (MOA) signing ceremony held at the VS Hotel Convention Center in Quezon City last Monday, Oct. 6.
          </p>
                <div className="news-links-wrapper">
                  <span className="read-more-label">Read More →</span>
                  <div className="source-links">
                    <a href="https://mb.com.ph/2025/12/20/victoria-sports-club-mounts-first-fun-run-uniting-wellness-and-advocacy" target='_blank' rel='noreferrer'>Manila Bulletin</a>
                  </div>
                </div>
          
        </div>
      </div>

      {/* 4th News Card */}
      <div className="news-card alternate">
        <div className="news-image">
          <img src="/vscimages/news/rungma.jpg" alt="Victoria Sports Club Victory Run Poaster " />
        </div>
        <div className="news-content">
          {/* <h1>GMA NETWORK.COM</h1> */}
          <h2 className="news-item-title">Victoria Sports Club launches first fun run to build healthier, more sustainable communities</h2>
          {/* <p className="news-item-sub">A new space for wellness and productivity in Quezon City</p> */}
          <p className="news-item-body">
         Victoria Sports Club, the metro’s largest integrated wellness and lifestyle destination, is set to raise the bar in community-driven fitness as it stages its first-ever fun run, reinforcing its commitment to health, social responsibility, and sustainable community development.
          </p>

                <div className="news-links-wrapper">
                  <span className="read-more-label">Read More →</span>
                  <div className="source-links">
                    <a href="https://mb.com.ph/2025/12/20/victoria-sports-club-mounts-first-fun-run-uniting-wellness-and-advocacy" target='_blank' rel='noreferrer'>GMA Network.com</a>
                  </div>
                </div>
          
        </div>
      </div>


       {/* First News Card */}
      <div className="news-card">
        <div className="news-image">
          <img src="/vscimages/news/tree1.jpg" alt="Victoria Sports Club Christmas Tree Lighting 2025" />
        </div>
        <div className="news-content">
          <h2 className="news-item-title">Victoria Sports Club Christmas Tree Lighting 2025</h2>
          {/* <p className="news-item-sub">A new space for wellness and productivity in Quezon City</p> */}
          <p className="news-item-body">
         A night of sparkle, music, and shared holiday cheer. ✨🌲",
          </p>

          <div className="news-links-wrapper">
                  <span className="read-more-label">Read More →</span>
                  <div className="source-links">
                    <a href="https://www.facebook.com/thevictoriasportsclub/posts/pfbid02hmzUcZQmzKJPgnhiFUGpNuRRvkMjTYXKnDerh2QiYocQAzq9D53o1FM1gGodLbrel" target='_blank' rel='noreferrer'>Facebook.com</a>
                  </div>
                </div>
        
        </div>
      </div>


       {/* 6th News Card (Alternate) */}
        <div className="news-card alternate">
          <div className="news-image">
            <img src="/vscimages/news/tree2.jpg" alt="Victoria Sports Club Christmas Tree Lighting 2025" />
          </div>
          <div className="news-content">
            {/* <h1>FACEBOOK.COM</h1> */}
            <h2 className="news-item-title">Victoria Sports Club Christmas Tree Lighting 2025</h2>
            {/* <p className="news-item-sub">A new space for wellness and productivity in Quezon City</p> */}
            <p className="news-item-body">
            Our annual Christmas Tree Lighting illuminated not just EDSA, Quezon City, but the hearts of everyone who joined us.
            </p>

                  <div className="news-links-wrapper">
                    <span className="read-more-label">Read More →</span>
                    <div className="source-links">
                      <a href="https://www.facebook.com/thevictoriasportsclub/posts/pfbid02hmzUcZQmzKJPgnhiFUGpNuRRvkMjTYXKnDerh2QiYocQAzq9D53o1FM1gGodLbrel" target='_blank' rel='noreferrer'>Facebook.com</a>
                    </div>
                  </div>
            
          </div>
        </div>

        {/* 7th News Card */}
        <div className="news-card">
          <div className="news-image">
            <img src="/vscimages/news/titan.png" alt="VSCxPureblends Titan Ultra Giant Risers MOA Signing" />
          </div>
          <div className="news-content">
            {/* <h1>INQUIRER.NET</h1> */}
            <h2 className="news-item-title">Pureblends Titan Ultra Giant Risers partners with Victoria Sports Club</h2>
            {/* <p className="news-item-sub">A new space for wellness and productivity in Quezon City</p> */}
            <p className="news-item-body">
            The Pureblends Titan Ultra Giant Risers have officially designated Victoria Sports Club (VSC) as their training hub for the upcoming PBA 50th Season, following a Memorandum of Agreement (MOA) signing ceremony held at the VS Hotel Convention Center.
            The agreement solidifies a strategic partnership between Pureblends Titan Ultra Giant Risers and Victoria Sports Club, ensuring the team’s athletes have access to world-class training facilities and amenities for this highly competitive 2025 Philippine Basketball Association season.
            </p>

                  <div className="news-links-wrapper">
                    <span className="read-more-label">Read More →</span>
                    <div className="source-links">
                      <a href="https://business.inquirer.net/551540/pureblends-titan-ultra-giant-risers-partners-with-victoria-sports-club" target='_blank' rel='noreferrer'>Inquirer.net</a>
                    </div>
                  </div>
           
          </div>
        </div>

        {/* 8th News Card (Alternate) */}
        <div className="news-card alternate">
          <div className="news-image">
            <img src="/vscimages/news/titan1.png" alt="VSCxPureblends Titan Ultra Giant Risers MOA Signing" />
          </div>
          <div className="news-content">
            {/* <h1>MANILA BULLETIN</h1> */}
            <h2 className="news-item-title">Titan Ultra Giant Risers partner with Victoria Sports Club</h2>
            {/* <p className="news-item-sub">A new space for wellness and productivity in Quezon City</p> */}
            <p className="news-item-body">
            The Pureblends Titan Ultra Giant Risers have officially designated Victoria Sports Club (VSC) as their training hub for the upcoming PBA 50th Season, following a Memorandum of Agreement (MOA) signing ceremony held at the VS Hotel Convention Center in Quezon City last Monday, Oct. 6.
            </p>
            <div className="news-links-wrapper">
                    <span className="read-more-label">Read More →</span>
                    <div className="source-links">
                      <a href="https://mb.com.ph/2025/10/08/pureblends-titan-ultra-giant-risers-partners-with-victoria-sports-club" target='_blank' rel='noreferrer'>Manila Bulletin</a>
                    </div>
                  </div>
            
          </div>
        </div>

        {/* 9th News Card (Alternate) */}
        <div className="news-card">
          <div className="news-image">
            <img src="/vscimages/news/vscinema.png" alt="VS Cinema Opening" />
          </div>
          <div className="news-content">
            {/* <h1>DAILY TRIBUNE</h1> */}
            <h2 className="news-item-title">VS Cinema redefines entertainment with grand opening</h2>
            {/* <p className="news-item-sub">A new space for wellness and productivity in Quezon City</p> */}
            <p className="news-item-body">
            VS Hotel Corporation, in partnership with Rems Entertainment CEO Gabby Ramos, officially launched VS Cinema on September 8 with a red-carpet event at the 8th floor of Victoria Sports Tower. The grand opening featured a ribbon-cutting ceremony, a traditional blessing, and a performance by Douglas Nierras and his Power Dance troupe. The event was attended by notable figures from the film industry.
            </p>

            <div className="news-links-wrapper">
                    <span className="read-more-label">Read More →</span>
                    <div className="source-links">
                      <a href="https://tribune.net.ph/2024/09/13/vs-cinema-redefines-entertainment-with-grand-opening" target='_blank' rel='noreferrer'>Daily Tribune</a>
                    </div>
                  </div>
           
          </div>
        </div>

        {/* Thrid News Card (Alternate) */}
      
      </div>
  );
};

export default News;

